<template>
  <div class="nav-wrapper">
    <CovidNotice :isHidden="isSticky" v-if="!isLoggedIn" />
    <nav class="nav" v-bind:class="{ 'nav-sticky': isSticky, 'nav-hidden': !isShown && isSticky }">
      <div class="nav-container">
        <a aria-label="Početna" href="/">
          <img src="../../assets/logo-mobile.svg" class="logo-mobile" alt="Početna" />
        </a>
        <button
          class="hamburger"
          name="Menu"
          v-on:click="
            isMenuVisible = !isMenuVisible;
            toggleBodyOverflow();
          "
        >
          <div v-bind:class="['bar-1', isMenuVisible ? 'bar-1-animation' : '']"></div>
          <div v-bind:class="['bar-2', isMenuVisible ? 'bar-2-animation' : '']"></div>
        </button>
      </div>
      <div class="nav-container">
        <a aria-label="Početna" href="/" class="logo-anchor">
          <img src="../../assets/logo-desktop.svg" class="logo" alt="Početna" />
        </a>
        <ul v-bind:class="['menu', isMenuVisible ? 'menu-visible' : '']">
          <li>
            <a
              class="navbar-link"
              v-on:click="
                isMenuVisible = !isMenuVisible;
                isAutoScroll = true;
                toggleBodyOverflow();
                setWasClickedToScroll(true);
              "
              v-scroll-to="{ el: '#conference', offset: -100, duration: 700 }"
            >
              Konferencija
            </a>
          </li>
          <li v-if="shouldDisplaySchedule">
            <a
              class="navbar-link"
              v-on:click="
                isMenuVisible = !isMenuVisible;
                isAutoScroll = true;
                toggleBodyOverflow();
                setWasClickedToScroll(true);
              "
              v-scroll-to="{ el: '#schedule', offset: -100 }"
            >
              Raspored
            </a>
          </li>
          <li v-if="shouldDisplaySponsors">
            <a
              class="navbar-link"
              v-on:click="
                isMenuVisible = !isMenuVisible;
                isAutoScroll = true;
                toggleBodyOverflow();
                setWasClickedToScroll(true);
              "
              v-scroll-to="{ el: '#sponsors', offset: -100, duration: 1000 }"
            >
              Sponzori
            </a>
          </li>
          <li>
            <a
              class="navbar-link"
              v-on:click="
                isMenuVisible = !isMenuVisible;
                isAutoScroll = true;
                toggleBodyOverflow();
                setWasClickedToScroll(true);
              "
              v-scroll-to="{ el: '#contact', offset: -100, duration: 1500 }"
            >
              Kontakt
            </a>
          </li>
          <li v-if="(!isLoggedIn && isSticky) || (!isLoggedIn && windowWidth < 1150)">
            <template>
              <button
                class="navbar-register"
                v-on:click="
                  $emit('showRegistrationModal');
                  isMenuVisible = !isMenuVisible;
                  toggleBodyOverflow();
                "
              >
                Registracija
              </button>
            </template>
          </li>
          <li>
            <template v-if="(!isLoggedIn && isSticky) || (!isLoggedIn && windowWidth < 1150)">
              <button
                class="button"
                v-on:click="
                  $emit('showLoginModal');
                  isMenuVisible = !isMenuVisible;
                  toggleBodyOverflow();
                "
              >
                Prijava
              </button>
            </template>
            <template v-if="isLoggedIn">
              <button
                class="button"
                v-on:click="
                  routeToApp();
                  isMenuVisible = !isMenuVisible;
                  toggleBodyOverflow();
                "
              >
                APLIKACIJA
              </button>
            </template>
          </li>
          <li />
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
import throttle from 'lodash.throttle';

import CovidNotice from '@/components/landing-page/CovidNotice.vue';

export default {
  name: 'Navigation',
  components: {
    CovidNotice,
  },
  props: {
    setWasClickedToScroll: { type: Function },
  },
  data() {
    return {
      isMenuVisible: false,
      isSticky: false,
      isAutoScroll: false,
      isShown: true,
      prevScroll: 0,
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    isLoggedIn: function() {
      let token = localStorage.getItem('token');
      if (!token) return false;

      let decoded = this.$decode(token);

      if (!decoded) return false;

      return true;
    },
    shouldDisplaySponsors: function() {
      const sponsors = this.$store.getters['landing/sponsor'];

      if (!sponsors) {
        return false;
      }

      const sponsorsAsList = Object.values(sponsors);

      return sponsorsAsList.length !== 0;
    },
    shouldDisplaySchedule: function() {
      const events = this.$store.getters['landing/events'];

      if (!events) {
        return false;
      }

      const eventsAsList = Object.values(events);

      return eventsAsList.length !== 0;
    },
    isLoggedIn: function() {
      let token = localStorage.getItem('token');
      if (!token) return false;

      let decoded = this.$decode(token);

      if (!decoded) return false;

      return true;
    },
  },
  methods: {
    handleScroll: function() {
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;

      this.isShown = !this.isSticky || (currentScrollPosition > 0 && currentScrollPosition < this.lastScrollPosition);

      this.lastScrollPosition = currentScrollPosition;

      if (
        this.isAutoScroll ||
        (document.getElementsByClassName('container')[0] &&
          window.pageYOffset > (0.4 * document.getElementsByClassName('container')[0].offsetHeight) / 2)
      ) {
        this.isSticky = true;
        this.isAutoScroll = false;
      } else this.isSticky = false;
    },
    isAdmin: function() {
      let token = localStorage.getItem('token');
      if (!token) return false;

      let decoded = this.$decode(token);

      if (!decoded) return false;

      if (decoded.roles === 'Administrator') return true;

      return false;
    },
    toggleBodyOverflow: function() {
      if (this.isMenuVisible && window.innerWidth < 1024) document.body.classList.add('no-scroll');
      else document.body.classList.remove('no-scroll');
    },
    routeToApp: function() {
      this.isAdmin() ? this.$router.push('admin') : this.$router.push('app');
    },
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth;
    });
    if (document.getElementsByClassName('container')) {
      window.addEventListener('scroll', throttle(this.handleScroll, 300));
      this.handleScroll();
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style scoped>
.bar-1,
.bar-2 {
  width: 30px;
  height: 2px;
  border-radius: 1px;
  background-color: #fff;
  transition: 0.4s;
  margin: 0;
}

.bar-1 {
  margin-bottom: 10px;
}

.bar-1-animation {
  transform: translate(-1px, 8px) rotate(45deg);
}

.bar-2-animation {
  transform: translate(-1px, -5px) rotate(-45deg);
}
a:hover {
  cursor: pointer;
}

ul ul {
  list-style-type: none;
  display: flex;
  width: 150px;
  justify-content: space-between;
  align-items: center;
}

ul ul a {
  width: 25px;
  text-decoration: none;
}

ul ul img {
  max-width: 100%;
}

.container > li:last-of-type {
  padding-bottom: 55px;
}

.nav-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10;
}

.nav {
  padding-top: 16px;
  transition: transform 0.3s;
  padding-bottom: 16px;
  width: 100%;
}

.nav.nav-sticky {
  background-color: #162426;
  z-index: 99;
}

.nav.nav-hidden {
  transform: translate3d(0, -100%, 0);
}

.nav-container {
  max-width: 1440px;
  display: flex;
  margin: auto;
  justify-content: space-between;
  padding: 0 100px;
  align-items: center;
}

.logo-anchor {
  max-height: 48px;
}

.logo,
.logo-mobile {
  position: relative;
  z-index: 3;
  height: 35px;
}

.logo {
  display: none;
}

.menu {
  z-index: 2;
  position: fixed;
  list-style-type: none;
  pointer-events: none;
  background-color: #0a181b;
  opacity: 1;
  top: 0px;
  left: 0;
  width: 100%;
  height: 100vh;
  padding-top: 152px;
  display: flex;
  align-items: center;
  flex-direction: column;
  transform: translate3d(0, -100vh, 0);
  will-change: transform;
  transition: transform 0.25s ease-in-out;
}

.menu li {
  margin-bottom: 48px;
}

.menu a {
  position: relative;
  color: #fff;
  font-family: 'Fuse V.2 Display', 'Arial', sans-serif;
  font-size: 20px;
  font-weight: 800;
  letter-spacing: -0.14px;
  line-height: 21px;
}

.button {
  text-decoration: none;
  display: inline-block;
  border: 0;
  padding: 8px 28px;
  border-radius: 10px;
  background-color: #30cec2;
  color: #000;
  font-size: 16px;
  font-weight: 600;
  outline: 0;
  line-height: 24px;
  text-transform: none;
  transition: background-color 0.2s ease-in-out;
}

.button:hover {
  background-color: #35e5d8;
}

.navbar-register {
  color: #30cec2;
  font-size: 16px;
  font-weight: 600;
  line-height: 21px;
  border: 0;
  background: none;
  cursor: pointer;
  outline: 0;
  transition: color 0.2s ease-in-out;
}

.navbar-register:hover {
  color: #35e5d8;
}

.navbar-link {
  position: relative;
}

.navbar-link:hover {
  color: #fff;
}

.navbar-link:after {
  content: '';
  z-index: -1;
  width: 0;
  height: 4px;
  display: block;
  margin-top: -3px;
  right: 0;
  background: #30cec2;
  transition: width 0.2s ease;
  -webkit-transition: width 0.2s ease;
  border-radius: 1px;
}

.navbar-link:hover:after {
  width: 100%;
  left: 0;
  background: #30cec2;
}

.menu-visible li .navbar-link:after {
  background-color: transparent;
}

.menu-visible {
  pointer-events: inherit;
  transform: translate3d(0, 0, 0);
}

.hamburger {
  outline: transparent;
  z-index: 3;
  background: none;
  outline: 0;
  border: 0;
  display: flex;
  flex-direction: column;
  align-content: center;
  cursor: pointer;
}

.menu button {
  font-size: 20px;
}

@media screen and (min-width: 1150px) {
  .menu-visible li .navbar-link:after {
    all: unset;
  }

  .hamburger {
    display: none;
  }

  .nav {
    padding: 25px 0;
  }

  .logo {
    display: initial;
  }

  .logo-mobile {
    display: none;
  }

  .menu {
    position: relative !important;
    opacity: 1 !important;
    height: auto !important;
    transform: none !important;
    padding-top: 0;
    background-color: transparent !important;
    pointer-events: inherit !important;
    width: auto;
    flex-direction: row;
  }

  .menu li {
    margin-bottom: 0;
    margin-left: 50px;
  }

  .menu a {
    font-size: 16px;
    letter-spacing: -0.56px;
    line-height: 19px;
    font-weight: 600;
  }

  li:last-of-type {
    display: none;
  }

  .button:disabled {
    color: lightgray;
  }

  .menu button {
    font-size: 16px;
  }
}

@media screen and (max-width: 797px) {
  .nav-container {
    padding: 0 24px;
  }
}
</style>
